const MOCK_ORDER_DETAIL = {
  orderNo: '1e2c785-46a0-473c-df62-5b6bdedc3b5',
  userName: 'Circles Ops',
  userEmail: 'xyz@circles.asia',
  price: 30
}

const MOCK_ORDER_PROGRESS = {
  createdAt: '2022-05-24T05:37:16.201+00:00',
  updatedAt: '2022-05-25T18:24:47.481+00:00'
}

//preparingSims, deliveryScheduled, deliveryReady
const MOCK_ORDER_STATUS = {
  orderStatus: 'deliveryReady',
  clientScheduledDelivery: true,
  provisioningCompleted: true
}

export default {
  MOCK_ORDER_DETAIL,
  MOCK_ORDER_PROGRESS,
  MOCK_ORDER_STATUS
}
